/* global rp$, document, window */
var THE_SCRIPT = function () {
	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section links_list_js
	 ********************************************/
	(function ProductDetailsModule() {

		rp$(document).on('setProductDetails:html', function HandleNewProductDetailsHtml(evt, html) {
			rp$('.product-details-module').html(html);
		});

	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
